import { FC } from "react";
import {
  Divider,
  Popover,
  PopoverOrigin,
  PopoverProps,
  Stack,
  Typography,
} from "@mui/material";
import { Attachment } from "@/services/cloudchipr.api";
import { AttachmentItem } from "@/components/common/attachment-cell/AttachmentItem";

interface AttachmentPopoverProps {
  open: boolean;
  attachments: Attachment[];
  closeMenu(): void;
  anchor: HTMLElement | null;
  onClick(id: string): void;
}

export const AttachmentPopover: FC<AttachmentPopoverProps> = ({
  open,
  anchor,
  attachments,
  closeMenu,
  onClick,
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchor}
      onClose={closeMenu}
      transformOrigin={transformOrigin}
      anchorOrigin={anchorOrigin}
      slotProps={slotProps}
    >
      <Stack spacing={0.5} py={1}>
        <Typography variant="body1" fontWeight="medium" px={2}>
          Attachments ({attachments?.length})
        </Typography>
        <Divider />
        {attachments?.map((item, index) => {
          if (!item?.id) {
            return null;
          }
          return (
            <AttachmentItem
              key={item.id}
              id={item?.id ?? ""}
              onClick={onClick}
              showDivider={index !== attachments?.length - 1}
            />
          );
        })}
      </Stack>
    </Popover>
  );
};

const slotProps: PopoverProps["slotProps"] = {
  paper: {
    sx: {
      minWidth: 200,
      maxWidth: 400,
    },
  },
};

const anchorOrigin: PopoverOrigin = {
  horizontal: "center",
  vertical: "bottom",
};

const transformOrigin: PopoverOrigin = {
  horizontal: "center",
  vertical: "top",
};
